import get from 'lodash/get'
import { api } from 'API'
import { handleError } from 'API/error'

export async function uploadFile(file: File, onUploadProgress?: (progressEvt: any) => void): Promise<string> {
  const body = new FormData()
  body.append('file', file, file.name)
  try {
    const response = await api.post(`/upload-file`, body, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onUploadProgress ?? (() => {})
    })
    return response.data
  } catch (firstError) {
    try {
      const response = await api.post(`/upload-file`, body, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: onUploadProgress ?? (() => {})
      })
      return response.data
    } catch (error) {
      handleError(error as Error, 'API/fileUploader', 'uploadFile2')
      return ''
    }
  }
}

export async function uploadMultipleFiles(
  files: File[],
  onUploadProgress?: (progressEvt: any) => void
): Promise<string[]> {
  try {
    const body = new FormData()
    files.forEach((file) => body.append('files', file, file.name))
    const response = await api.post(`/upload-multiple-files`, body, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onUploadProgress ?? (() => {})
    })

    return response.data
  } catch (error) {
    const errorMessage: string = get(error, 'response.data.error.message', '') || JSON.stringify(error)
    console.log('getHousesAggregate ~ errorMessage', errorMessage)
    return []
  }
}

export async function getFileUrl(fileName: string): Promise<string> {
  try {
    const response = await api.get(`/file/${fileName}`)
    return response.data
  } catch (error) {
    const errorMessage: string = get(error, 'response.data.error.message', '') || JSON.stringify(error)
    console.log('getFileUrl ~ errorMessage', errorMessage)
    return ''
  }
}
